import { inject as injectBranding } from '@angular/core';
import { SiteBrandingService } from '../services/site-branding.service';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-footer',
  imports : [RouterLink],
  standalone: true,
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  readonly branding = injectBranding(SiteBrandingService);
  currentYear = new Date().getFullYear();

  constructor(private http: HttpClient) {}

  trackButtonClick(label: string) {
    this.http.post(environment.apiUrl + '/insights/track', { 
      eventType: "ButtonClick",
      label: label +" Link"
    }).subscribe({
      next: () => console.log(`Button click tracked: ${label}`),
      error: err => console.error('Button click tracking error:', err)
    });
  }
}
